var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 4a1 1 0 011 1v14a1 1 0 01-1 1H9.454c-.288 0-.563-.125-.753-.342l-6.125-7a1 1 0 010-1.316l6.125-7c.19-.217.465-.342.753-.342H21zm-4.222 5.22a.75.75 0 00-1.004-.052l-.056.052-1.719 1.718L12.28 9.22l-.056-.052a.75.75 0 00-1.056 1.056l.052.056L12.938 12l-1.718 1.719-.051.056a.75.75 0 001.055 1.055l.056-.05L14 13.058l1.719 1.72.056.05a.75.75 0 001.055-1.055l-.05-.056-1.72-1.719 1.72-1.719.051-.056a.75.75 0 00-.052-1.004z",
    fill: "currentColor"
  })));
}
SvgDeleteFilled.displayName = 'DeleteFilled';
export default SvgDeleteFilled;